import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface ExportCheckinsResult {
  startDate: string; // YYYY-MM-DD
  endDate: string;   // YYYY-MM-DD
  format: 'csv' | 'pdf';
}

@Component({
  selector: 'df-export-checkins',
  templateUrl: './export-checkins.component.html',
  styleUrls: ['./export-checkins.component.scss']
})
export class ExportCheckinsComponent {
  @Input() memberName: string = '';

  exportForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.exportForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      format: ['pdf', Validators.required]
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  export(): void {
    if (!this.exportForm.valid) return;

    const v = this.exportForm.value;
    const result: ExportCheckinsResult = {
      startDate: v.startDate,
      endDate: v.endDate,
      format: v.format
    };

    this.activeModal.close(result);
  }
}
